const composeValidators =
  (...validators) =>
  (value) =>
    validators.reduce((error, validator) => error || validator(value), undefined)

const maxChars = (max) => (value) =>
  !value || (value && value.length <= max) ? undefined : `Max characters allowed: ${max}`

const mustBeNumber = (value) => (isNaN(value) ? 'Must be a number' : undefined)

const required = (value) => (value ? undefined : '* Required')

//https://stackoverflow.com/questions/7905929/how-to-test-valid-uuid-guid
const isUUID = (value) => {
  if (!value) return false
  return (
    value.match(/^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i) !==
    null
  )
}

export { composeValidators, isUUID, maxChars, mustBeNumber, required }



// WEBPACK FOOTER //
// ./src/modules/Forms/utils/validations.js